<template>
  <el-table :data="tableData" :stripe="true" :header-cell-style="tableHeaderCellStyle">
    <el-table-column prop="courseName" label="课程" align="center" show-overflow-tooltip></el-table-column>
    <el-table-column prop="chapterName" label="章节" align="center" show-overflow-tooltip></el-table-column>
    <el-table-column prop="classesName" label="课时" align="center" show-overflow-tooltip width="200"></el-table-column>
    <el-table-column prop="classesType" label="授课类型" align="center">
      <template slot-scope="scope">
        <span style="color: #3d6fd8" v-show="scope.row.classesType == 0">录播</span>
        <span style="color: #9c2883" v-show="scope.row.classesType == 1">直播</span>
        <span style="color: #5dd02c" v-show="scope.row.classesType == 2">线下</span>
      </template>
    </el-table-column>
    <el-table-column prop="classStartTime" label="开始时间" align="center"></el-table-column>
    <el-table-column prop="classEndTime" label="结束时间" align="center"></el-table-column>
    <el-table-column prop="className" label="授课班级" align="center"></el-table-column>
    <el-table-column align="center" label="操作" width="180">
      <template slot-scope="scope">
        <el-button v-show="scope.row.classesType == 0" type="text" v-on:click="startLiveTap(scope.$index, scope.row)">进入房间</el-button>
        <el-button v-show="scope.row.classesType == 1" type="text" v-on:click="startLiveTap(scope.$index, scope.row)">开始直播</el-button>
        <el-button type="text" @click="downLoadFile(scope.$index, scope.row)">资料下载</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import CommonStyle from "@/utils/CommonStyle";
export default {
  name: "TeacherSchedule",
  data () {
    return {
      tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
      tableData: []
    }
  },
  mounted () {
    let that = this;
    that.HttpConnection.get("/learn/usercourse/teacher/schedule").then(function (response) {
      that.tableData = response.data;
    });
  },
  methods: {
    startLiveTap (index, row) {
      let that = this;
      let _userInfo = this.$store.state.user.userInfo;
      let _classInfo = {
        teacherId: _userInfo.userId,
        teacherName: _userInfo.nickName,
        classId: row.classId,
        classesId: row.classesId,
        classesName: row.classesName,
        classesType: row.classesType,
        videoName: row.videoName,
        videoUrl: row.videoUrl,
        materialsName: row.materialsName,
        materialsUrl: row.materialsUrl,
        scheduleId: row.scheduleId
      };
      sessionStorage.setItem("classInfo", JSON.stringify(_classInfo));
      that.$store.commit("clearLiveMessage");
      if (row.classesType == 0) { // 录播课程
        that.$router.push({ path: "/RoomEnter" });
        // let _routeUrl = this.$router.resolve({ path: "/RoomEnter" });
        // window.open(_routeUrl.href, "_blank");
      } else if (row.classesType == 1) { // 直播课程
        that.$router.push({ path: "/RoomCreate" });
        // let _routeUrl = this.$router.resolve({ path: "/RoomCreate" });
        // window.open(_routeUrl.href, "_blank");
      } else if (row.classesType == 2) { // 线下课程

      }
    },
    downLoadFile (index, row) {
      let that = this;
      let a = document.createElement("a");
      a.href = process.env.VUE_APP_imagePath + row.materialsUrl;
      document.body.appendChild(a);
      a.click(); // 下载
      URL.revokeObjectURL(a.href); // 释放URL 对象
      document.body.removeChild(a); // 删除 a 标签
    }
  }
};
</script>

<style scoped>
</style>
